import React from "react";

interface Props {
  value: string
  dropdownOptions: server.dto.DropdownOption[]
}

const ReadonlyCustomOption = ({ value, dropdownOptions }: Props) => {
  return <>{dropdownOptions.find(option => option.key === value)?.value ?? value}</>;
};

export default ReadonlyCustomOption;
